import type { DiffLine } from "./computeDiff";

export type SideBySideRow = {
  left: string | null;
  right: string | null;
  rowKind: "both" | "leftOnly" | "rightOnly";
};

/**
 * Maps unified diff lines to aligned left/right columns for side-by-side view.
 */
export function buildSideBySideRows(lines: DiffLine[]): SideBySideRow[] {
  const rows: SideBySideRow[] = [];
  for (const line of lines) {
    if (line.type === "unchanged") {
      rows.push({
        left: line.content,
        right: line.content,
        rowKind: "both",
      });
    } else if (line.type === "removed") {
      rows.push({
        left: line.content,
        right: null,
        rowKind: "leftOnly",
      });
    } else {
      rows.push({
        left: null,
        right: line.content,
        rowKind: "rightOnly",
      });
    }
  }
  return rows;
}
